/* src/app/shared/contract/contract-item/contract-commitment/category-group-criteria-component/criteria-group.component.scss */
.tv-ns-primary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #F03C64;
  border: 1px solid #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-light-bg:hover {
  background-color: #CC3456;
  border: 1px solid #CC3456;
}
.tv-ns-primary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-primary-large-button-on-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  border: 1px solid #F03C64;
  background-color: #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-dark-bg:hover {
  border: 1px solid #F03C64;
  background-color: transparent;
}
.tv-ns-primary-large-button-on-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-secondary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #FFF;
  color: #244666;
  border: 1px solid #244666;
}
.tv-ns-secondary-large-button-on-light-bg:hover {
  background-color: #244666;
  border: 1px solid #244666;
  color: #FFF;
}
.tv-ns-secondary-large-button-on-light-bg:hover svg path {
  fill: #FFF !important;
}
.tv-ns-secondary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-secondary-large-button-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: transparent;
  color: #DFEBF7;
  border: 1px solid #DFEBF7;
}
.tv-ns-secondary-large-button-dark-bg:hover {
  border: 1px solid #DFEBF7;
  background-color: #DFEBF7;
  color: #244666;
}
.tv-ns-secondary-large-button-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-validation-large-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  font: 700 13px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-large-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-large-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-validation-small-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-small-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-validation-small-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-small-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-small-blue-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #0083FF;
  border: 1px solid #0083FF;
  color: #FFF;
}
.tv-ns-small-blue-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-small-blue-button:hover {
  background-color: #FFF;
  border: 1px solid #0083FF;
  color: #0083FF;
}
.tv-ns-small-blue-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.light-flex-card {
  background-color: #FFF;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  padding: 7px 10px;
  margin-bottom: 20px;
}
.light-border {
  border: 1px solid #DFEBF7;
  border-radius: 10px;
}
.sub-title {
  font: 700 16px FranceTV Brown;
  color: #001A33;
}
.third-title {
  font: 700 14px FranceTV Brown;
  color: #F03C64;
  margin-bottom: 4px;
}
.content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin: 0;
}
.categories-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.category-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  height: 100%;
}
.criteria-categories-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: calc(50% - 10px);
  height: fit-content;
  padding: 15px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.criteria-categories-parent-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: calc(50% - 10px);
  height: fit-content;
}
.criteria-categories-child-container {
  padding: 15px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.medium-category {
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-radius: 5px;
  padding: 15px;
  min-width: 300px;
  width: calc(33.3333333333% - 13.3333333333px);
  flex-basis: calc(33.3333333333% - 13.3333333333px);
  max-width: calc(33.3333333333% - 13.3333333333px);
  background-color: rgba(36, 70, 102, 0.05);
}
.large-category {
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-radius: 5px;
  min-width: 300px;
  width: calc(50% - 10px);
  flex-basis: calc(50% - 10px);
  max-width: calc(50% - 10px);
}
.full-size-category {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 10px;
  min-width: 300px;
  width: 100%;
}
.category-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
}
.commitment-container {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
.commitment-title {
  display: flex;
  gap: 5px;
  background-color: rgba(107, 144, 179, 0.05);
  font: 400 15px FranceTV Brown;
  color: #6B90B3;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
}
.sublevel-icon {
  font-size: 15px;
  font-weight: 600;
  width: 15px;
  height: 15px;
  color: #6B90B3;
}
.commitment-suffix {
  font: 400 15px FranceTV Brown;
  font-size: 12px;
  color: #001A33;
  margin-right: 5px;
}
.commitment-prefix {
  font: 400 12px FranceTV Brown;
  font-size: 12px;
  color: #001A33;
  margin-left: 5px;
}
.total-container {
  display: flex;
  flex-direction: column;
  margin-top: auto;
  gap: 10px;
  min-width: 100%;
  background-color: transparent;
}
.calcul-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: white;
  border-radius: 5px;
  width: 100%;
}
.action-buttons-container {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}
.full-height {
  height: 100%;
}
.invisible {
  opacity: 0;
}
.disabled-form-field :hover {
  cursor: not-allowed;
}
.projected-rate-container {
  display: flex;
  gap: 10px;
  align-items: center;
}
.projected-rate {
  display: flex;
  flex-direction: column;
}
.projected-rate-error {
  color: #F03C64;
  font: 400 12px FranceTV Brown;
  margin-top: -5px;
  margin-bottom: 10px;
}
.mat-expansion-panel-header {
  height: 58px;
  padding: 0 15px 0 10px;
}
.mat-expansion-indicator {
  background-color: red;
}
.mat-expansion-panel-body {
  padding: 0 0 15px !important;
}
.mat-divider {
  border-top-color: #DFEBF7;
}
/*# sourceMappingURL=criteria-group.component.css.map */
